import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpHelper {
  constructor() {
  }

  public getRequestOptions(shouldAppend: boolean = true) {
    return { headers: this.getHeaders(), params: this.getBasicQueryParams(shouldAppend), withCredentials: true };
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  private getBasicQueryParams(shouldAppend: boolean = true): HttpParams {
    let basicQueryParams = new HttpParams();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (shouldAppend) {
      basicQueryParams = basicQueryParams.append('accountKey', urlParams.get('accountKey'));
      basicQueryParams = basicQueryParams.append('sessionId', urlParams.get('sessionId'));
    }

    return basicQueryParams;
  }
}
